import { Base64 } from 'js-base64';
import UserCache from '@panda/cache/src/user/cache';
import { LoginType, LOGIN_FROM } from '@panda/cache/src/user/define';
import { JSBridgeUtil, mobileUtil, stringUtil } from '@panda/tool';
import wx from 'weixin-js-sdk';

const userCache = new UserCache();
const jsBridge = new JSBridgeUtil();

const HOME_PAGE = '//geek.163.com';

export const loginGeekPC = () => {
  const baseLoginUrl = `${HOME_PAGE}/path/member/login?returnUrl=`;
  window.location.href = `${baseLoginUrl}${Base64.encode(window.location.href)}`;
};

export const loginPanda = (inCurrentPage?: boolean, loginSuccessCallback?: () => void) => {
  const inviteCode = stringUtil.getParam('inviteCode');
  const inviteParam = inviteCode ? `&inviteCode=${inviteCode}` : '';
  if (!inCurrentPage) {
    window.location.href = `/login?returnUrl=${encodeURIComponent(window.location.href)}${inviteParam}`;
  } else {
    userCache.loginPanda({
      headers: {
        'PANDA-INVITE': inviteCode,
      },
      data: {
        from: LOGIN_FROM.WEB,
        inviteCode,
      },
    })
      .then((res) => {
      // 接口返回成功且鉴权成功，才算是登录成功
        if (res) {
          if (loginSuccessCallback) {
            loginSuccessCallback();
          }
        }
      });
  }
};

export const loginGeek = () => {
  jsBridge.ready(() => {
    jsBridge.call('nativelogin', {
      returnUrl: window.location.href,
    });
  });
};

export const loginMiniProgram = () => {
  wx.miniProgram.navigateTo({
    url: '/pages/login/loginIndex/index?reLogin=true',
  });
};

export const login = () => {
  // geek app端
  if (mobileUtil.isGeekApp()) {
    loginGeek();
    return;
  }

  // 如果是微信小程序，登录小程序
  if (mobileUtil.isMiniprogram()) {
    loginMiniProgram();
    return;
  }

  // 如果是手机端，则都是新页面，直接用有道登录
  if (mobileUtil.isMobileAll()) {
    loginPanda();
    return;
  }

  // 否则，需要跳转到geek登录页进行登录
  loginGeekPC();
};

export const logout = () => {
  console.log('logout!!!!');
  Promise.all([userCache.logoutYouDao({}), userCache.logoutPanda({})]).then(() => {
    const logoutUrl = '//geek.163.com/eds/api/v1/login/logout?redirectUri=';
    const src = `${logoutUrl}${Base64.encode(HOME_PAGE)}`;
    const script = document.createElement('script');
    script.src = src;
    document.body.appendChild(script);
    script.onload = () => {
      window.location.reload();
    };
  });
};

export const logoutApp = (accountType: LoginType) => {
  jsBridge.ready(() => {
    jsBridge.call('exitLogin', {
      accountType,
    });
  });
};

/**
 * 判断是否登录，未登录状态跳转登录页面
 */
export const checkIsLogin = (doNotGoLogin?: boolean) => {
  const isLogin = UserCache.isLogin();
  if (isLogin) {
    return Promise.resolve();
  }
  // 未登录不进行登录操作
  if (doNotGoLogin) {
    return userCache.getUserInfoPure({});
  }
  // 未登录状态接口返回401，跳转登录页
  return userCache.getUserInfo({});
};

export const isWechatAccount = () => window.PandaNamespace.userAccount.loginType === LoginType.Wechat;

/**
 * 校验返回地址是否是geek域名
 * @param returnUrl
 */
export const checkReturnUrl = (returnUrl: string) => {
  const { hostname } = new URL(returnUrl, window.location.href);
  return /(geek\.163\.com|youdao\.com|kada\.com|kada\.163\.com)$/i.test(hostname);
};

export const refineReturnUrl = (returnUrl: string) => {
  if (checkReturnUrl(returnUrl)) {
    return returnUrl;
  }
  return HOME_PAGE;
};
